export const normalizeClientSearchText = (value) =>
  String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase("es")
    .trim();

export function attachLocalsToClients(persons, locals) {
  const byPersonId = new Map();

  locals.forEach((local) => {
    if (local.LocalPersonId == null) return;
    const key = String(local.LocalPersonId);
    if (!byPersonId.has(key)) byPersonId.set(key, []);
    byPersonId.get(key).push(local);
  });

  return persons.map((person) => ({
    ...person,
    Locals: byPersonId.get(String(person.Id)) || [],
  }));
}

export function filterClients(persons, query) {
  const searchQuery = normalizeClientSearchText(query);
  if (!searchQuery) return persons;

  return persons.filter((person) =>
    [
      person.Name,
      person.Contact,
      person.Department,
      person.City,
      ...(person.Locals || []).map((local) => local.Name),
    ].some((value) => normalizeClientSearchText(value).includes(searchQuery))
  );
}

const clientCollator = new Intl.Collator("es", { sensitivity: "base", numeric: true });

export function sortClients(persons, sort) {
  if (!sort) return persons;

  const valueFor = (person) =>
    sort.column === "City"
      ? `${person.Department ?? ""} · ${person.City ?? ""}`
      : person.Name ?? "";
  const direction = sort.direction === "desc" ? -1 : 1;

  return persons
    .map((person, index) => ({ person, index }))
    .sort((a, b) => {
      const result = clientCollator.compare(String(valueFor(a.person)), String(valueFor(b.person)));
      return result * direction || a.index - b.index;
    })
    .map(({ person }) => person);
}

const timestamp = (value) => {
  const time = value ? new Date(value).getTime() : 0;
  return Number.isNaN(time) ? 0 : time;
};

export function groupClientLocals(locals = []) {
  const byRoot = new Map();

  locals.forEach((local) => {
    const rootId = local.ParentLocalId ?? local.Id;
    const key = String(rootId);
    if (!byRoot.has(key)) byRoot.set(key, { rootId, periods: [] });
    byRoot.get(key).periods.push(local);
  });

  return Array.from(byRoot.values())
    .map(({ rootId, periods }) => {
      periods.sort(
        (a, b) =>
          (Number(a.CycleNumber) || 0) - (Number(b.CycleNumber) || 0) ||
          timestamp(a.CreatedAt) - timestamp(b.CreatedAt) ||
          Number(a.Id) - Number(b.Id)
      );
      const current = [...periods].reverse().find((period) => period.IsActive === true);
      const latest = current || periods[periods.length - 1];
      return {
        rootId,
        name: latest.Name,
        address: latest.Address,
        city: latest.City,
        department: latest.Department,
        isActive: Boolean(current),
        periods,
      };
    })
    .sort(
      (a, b) =>
        Number(b.isActive) - Number(a.isActive) ||
        String(a.name ?? "").localeCompare(String(b.name ?? ""), "es", {
          sensitivity: "base",
        })
    );
}
